// extracted by mini-css-extract-plugin
export default {"create_post":"CreatePost_create_post__dHFjE","form_container":"CreatePost_form_container__BUBG0","btn":"CreatePost_btn__v-W3h","error":"CreatePost_error__hdFER"};